import React, { Component } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import DocumentTitle from "react-document-title";

import {
    selectLocation,
    selectLocations,
    selectedStories,
    selectEraContent,
    selectEraChurches,
    selectNewsBox,
    selectHomepageLoaded,
} from "./../../selectors.js";
import { MetaTitle } from "./../../settings";

// Components
import "./style.css";
import EraPreviewBox from "./../../components/EraPreviewBox";
import HistoryPreviewBox from "./../../components/HistoryPreviewBox";
import MediumSpacer from "./../../components/MediumSpacer";
import ShowCaseBox from "./../../components/ShowCaseBox";

import ChurchIcon from "./../../images/church.svg";
import StoryIcon from "./../../images/story.svg";

import { updateCanonicalLink } from "../../helpers/helpers.js";

class Homepage extends Component {
    componentDidMount() {
        updateCanonicalLink();
    }

    printEraPreviewBoxes() {
        const { eraContent, eraChurches } = this.props;

        return eraChurches.map(({ fields }) => {
            const eraTitle =
                eraContent &&
                eraContent.find((item) => item.sys.id === fields.era.sys.id)
                    .fields.title;
            return (
                <EraPreviewBox
                    key={fields.id}
                    title={fields.name}
                    link={`/kirke/${fields.id}`}
                    description={fields.ingress}
                    year={eraTitle}
                    filter={selectEraContent ? true : false}
                    yearTo={`/sok?epoke=${eraTitle}`}
                    image={fields.mainimage}
                />
            );
        });
    }

    render() {
        const { homepageLoaded, eraChurches, selectedStories, newsBox } =
            this.props;
        if (!homepageLoaded) return null;

        return (
            <DocumentTitle title={`Forsiden ${MetaTitle}`}>
                <div className="homepage">
                    <MediumSpacer />
                    <div className="container">
                        <div className="page-section">
                            {newsBox && newsBox.visible && (
                                <ShowCaseBox
                                    image={newsBox.image && newsBox.image}
                                    title={newsBox.title}
                                    text={newsBox.content} 
                                />
                            )}

                            <MediumSpacer />
                            <h1 className="visually-hidden">Kirkesøk hovedside</h1>
                            <h2 className="page-title">
                                <img
                                    className="page-title__icon"
                                    src={ChurchIcon}
                                    alt="Ikon for epoker"
                                />
                                Kirker fra forskjellige epoker
                            </h2>
                            {/* Kirkeutlisting */}
                            <div className="grid-column-3">
                                {eraChurches && this.printEraPreviewBoxes()}
                            </div>
                        </div>

                        <MediumSpacer />

                        <div className="page-section">
                            <h2 className="page-title">
                                <img
                                    className="page-title__icon"
                                    src={StoryIcon}
                                    alt="Ikon for historier"
                                />
                                Historier fra norske kirker
                            </h2>
                            <div className="grid-column-3">
                                {selectedStories &&
                                    selectedStories.map((data) => {
                                        const img = data.fields.featuredImage;
                                        // Removes everything afer "?" (questionmark) if there is any.
                                        // Does this because a user might upload a string to Contentful like this: ....image.png?w=800
                                        // Then we would like to remove the size of 800 and instead use our settings
                                        const imageUrl =
                                            data.fields.hasOwnProperty(
                                                "featuredImage"
                                            )
                                                ? `${img.substring(
                                                    0,
                                                    img.indexOf("?") !== -1
                                                        ? img.indexOf("?")
                                                        : img.length
                                                )}?w=510`
                                                : "https://placehold.co/600x400";

                                        return (
                                            <HistoryPreviewBox
                                                key={data.sys.id}
                                                title={data.fields.title}
                                                link={`/historier/${data.sys.id}`}
                                                description={data.fields.body}
                                                image={imageUrl}
                                            />
                                        );
                                    })}
                            </div>
                        </div>

                        <MediumSpacer />
                    </div>{" "}
                    {/* END container */}
                </div>
            </DocumentTitle>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    locations: selectLocations(),
    location: selectLocation(),
    eraContent: selectEraContent(),
    eraChurches: selectEraChurches(),
    selectedStories: selectedStories(),
    newsBox: selectNewsBox(),
    homepageLoaded: selectHomepageLoaded(),
});

export default connect(mapStateToProps)(Homepage);



// WEBPACK FOOTER //
// ./src/containers/Homepage/index.js